import { render, staticRenderFns } from "./score-assessment-custome-divider.vue?vue&type=template&id=79d72032&"
import script from "./score-assessment-custome-divider.vue?vue&type=script&lang=js&"
export * from "./score-assessment-custome-divider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports